import React from 'react';
import { StyleSheet } from 'react-native';
import { HStack } from '../Stack';
import type { ContainerProps } from './Rating.types';

export const Container = React.memo((props: ContainerProps) => {
  const { minValue, value, starCount, children } = props;

  return (
    <HStack
      testID="sg-rating"
      accessibilityRole="radiogroup"
      accessibilityValue={{
        min: minValue,
        now: value,
        max: starCount,
      }}
      style={styles.container}
      itemsPerRow={starCount}
      customSpacing={0}
    >
      {children}
    </HStack>
  );
});

const styles = StyleSheet.create({
  container: {
    maxHeight: 32,
  },
});
